import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

const Testimonials = () => {

}

export default Testimonials